import { render } from "./customers.vue?vue&type=template&id=46359d2d&scoped=true"
import script from "./customers.vue?vue&type=script&lang=js"
export * from "./customers.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-46359d2d"

export default script